import estilos from './servicios/Servicios.module.css'

function Servicios({src, alt, titulo, texto}) {
    return (
       <>
      <div className={estilos.div}>
        <h3 className={estilos.h3}>
            {titulo}
        </h3>
        <img className={estilos.img} src={src} alt={alt} />
        <p className={estilos.p}> 
          {texto}
        </p>
      </div>
      </>
    );
  };
  
  export default Servicios;